import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { updateProfileEmail } from "../../services/portalAluno/profile/profileService";
import { updateAuthEmail } from "../../store/ducks/auth/actions";
import type { ApplicationState } from "../../store";

const useProfile = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const mutation = useMutation({
    mutationFn: (email: string) => {
      if (!auth?.idUsuario) throw new Error("Sessão de usuário inválida.");
      return updateProfileEmail(email);
    },
    onSuccess: (email) => dispatch(updateAuthEmail(email)),
  });

  return { auth, ...mutation };
};

export default useProfile;
